import qs from 'qs'
import axios, {
  AxiosError,
  AxiosPromise,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios'
import merge from 'lodash.merge'
import { Get } from './Get'
import { Put } from './Put'
import { Post } from './Post'
// import {env} from '../Application';
import { UserPreferencesData, RegisterUserData } from './UserService.d'
import { store } from '~/Store'
import { UserSelectors } from '~/Store/User'
import { Delete } from './Delete'
import { ApiHelpers, APIHosts } from './ApiHelpers'

export interface ClaimResponse {
  guid: string
  claimType: string
  claimValue: string
  productId: string
  product?: any
  rolesProductClaims?: any
  userProductClaims?: any
  licenseTypeProductClaims?: any
}

export interface ProductClaim {
  productId: string
  claimType: string
  claimValue: string
}

class ClaimServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  public Put = {
    updateProductClaim: (
      productClaimId: string,
      input: ProductClaim,
      options: AxiosRequestConfig = {},
    ) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Put(`${baseUrl}/Claims/${productClaimId}`, input, options);
    },
  }

  public Get = {
    getClaims: (
      options: AxiosRequestConfig = {},
    ): AxiosPromise<ClaimResponse | AxiosError> => {
      const baseUrl = this.getHost(this.ApiHost);
      return Get(`${baseUrl}/Claims`, options);
    },
  }

  public Post = {
    addNewProductClaim: (
      input: ProductClaim,
      options: AxiosRequestConfig = {},
    ) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Post(`${baseUrl}/Claims`, input, options);
    },
  }

  public Delete = {}
}

export const ClaimService = new ClaimServiceController()
